/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".wx-icon[_ngcontent-%COMP%]{display:inline-block;background:#777;border-radius:50%;width:16px;height:16px;border:2px solid #eee;box-shadow:1px 2px 4px #444;vertical-align:middle}.wx-icon--small[_ngcontent-%COMP%]{width:12px;height:12px}.wx-icon--vfr[_ngcontent-%COMP%]{background:#0a3}.wx-icon--mvfr[_ngcontent-%COMP%]{background:#00e}.wx-icon--ifr[_ngcontent-%COMP%]{background:red}.wx-icon--lifr[_ngcontent-%COMP%]{background:#c3f}"];
export { styles as styles };
